import { render } from "./registerView.vue?vue&type=template&id=fe82256c"
import script from "./registerView.vue?vue&type=script&lang=js"
export * from "./registerView.vue?vue&type=script&lang=js"

import "./registerView.vue?vue&type=style&index=0&id=fe82256c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__